import { Link } from "react-router-dom";

export const SeeInPerson = ({ referenceUrl }) => (
  <section className="edge py-16" data-testid="see-in-person">
    <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
      <h2 className="text-2xl font-light tracking-editorial md:text-3xl">See it in person.</h2>
      <div className="flex flex-wrap gap-8">
        <Link
          to="/contact"
          data-testid="see-in-person-showroom"
          className="border-b border-foreground pb-1 text-sm uppercase tracking-[0.16em]"
        >
          Get in Touch →
        </Link>
        {referenceUrl && (
          <a
            href={referenceUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="see-in-person-reference"
            className="border-b border-foreground pb-1 text-sm uppercase tracking-[0.16em]"
          >
            Reference Sheet ↗
          </a>
        )}
      </div>
    </div>
  </section>
);
